import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  AuditLogSearchFilterModel,
  AuditLogType,
  SegmentAuditLogsListConfig,
  TtdCategoryAuditLogsListConfig
} from './audit-logs.service';

@Component({
  selector: 'app-audit-logs',
  template: `
    <div class="audit-logs-wrapper">
      <mat-button-toggle-group style="margin: 10px" name="fontStyle" aria-label="Font Style"
                               [value]="activeLogType"
                               (change)="changeState($event.value)">
        <mat-button-toggle *ngFor="let state of activeLogTypeKeys" [value]="state"
                           [matTooltip]="'Displays '+state.toLowerCase()+' audit logs'"
                           [attr.data-cy]="'audit-log-state-'+state.toLowerCase()">
          {{state.split('_').join(' ') | titlecase}}
        </mat-button-toggle>
      </mat-button-toggle-group>

      <ng-container [ngSwitch]="activeLogType">
        <ng-container *ngSwitchCase="auditLogType.SEGMENT">
          <div class="table-filter-controls">
            <app-audit-logs-search [config]="segmentAuditLogListConfig"
                                   (searchForm)="handleSearchForm($event)"></app-audit-logs-search>
          </div>
          <app-audit-logs-table [searchFormValues]="searchFormValues"
                                [config]="segmentAuditLogListConfig"></app-audit-logs-table>
        </ng-container>
        <ng-container *ngSwitchCase="auditLogType.TTD_CATEGORY">
          <div class="table-filter-controls">
            <app-audit-logs-search [config]="ttdCategoryAuditLogListConfig"
                                   (searchForm)="handleSearchForm($event)"></app-audit-logs-search>
          </div>
          <app-audit-logs-table [searchFormValues]="searchFormValues"
                                [config]="ttdCategoryAuditLogListConfig"></app-audit-logs-table>
        </ng-container>
      </ng-container>
    </div>
  `,
  styleUrls: ['./audit-logs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuditLogsComponent implements OnInit {
  activeLogType: AuditLogType = AuditLogType.SEGMENT;
  auditLogType = AuditLogType;
  segmentAuditLogListConfig = SegmentAuditLogsListConfig;
  ttdCategoryAuditLogListConfig = TtdCategoryAuditLogsListConfig;
  activeLogTypeKeys = Object.keys(AuditLogType);
  searchFormValues: AuditLogSearchFilterModel = {};
  constructor() { }

  ngOnInit(): void {
  }

  changeState(value: AuditLogType) {
    this.activeLogType = value;
  }

  handleSearchForm(formValue: AuditLogSearchFilterModel) {
    this.searchFormValues = formValue;
  }

}
